import React from "react";

const Footer = () => {
  return (
    <div className="bg-white border-t border-gray-300 p-4 dark:bg-gray-900 dark:border-gray-700">
      <footer className="flex flex-col md:flex-row items-center justify-center gap-2 px-6 text-sm text-gray-500 dark:text-gray-400">
        <span className="p-0">Copyright © 2025 Invyntra.</span>
        <span className="p-0">
          Design with
          <span className="text-red-500"> ♥ </span>by Venus Software Solutions.
        </span>
        <span className="p-0">All rights reserved.</span>
      </footer>
    </div>
  );
};

export default Footer;
